<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Overview</div><v-divider class="div-after"/>
    <div class="body-1">
      For this checkpoint, I implemented tone reproduction operators based on work done by <span class="font-weight-bold">Ward</span>
      and <span class="font-weight-bold">Reinhard</span>. I also adjusted some values in my scene to get results closer to
      the target image originally discussed in my first few updates.The two images below show some end results of my work. 
      I'll dive a bit into the Ward/Reinhard implementations specifically, and touch on some issues I've identified with my system.
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_15.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 15</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_reinhard_015.png`)"/>
      <div class="font-weight-medium">Reinhard where a = .015 and LD_MAX = 15</div>

    <v-divider class="spacer"/><div class="headline font-weight-bold">Luminance</div><v-divider class="div-after"/>
    <div class="body-1">
      The images above don't look too shabby! However, LD_MAX being 15 and a key value of .015 seem a little suspect. Additionally,
      the scene was captured with a single light source with an RGB luminance value of 8,000. That doesn't sound very right at all,
      and as a result I ultimately needed to lower the parameters for my Ward/Reinhard post processing operators.  
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_reinhard_05.png`)"/>
      <div class="font-weight-medium">Reinhard where a = .05 - UH OH</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Reinhard Results</div><v-divider class="div-after"/>
    <v-img class="u-image" :src="require(`../assets/updates/10/10_reinhard_ld2a15.png`)"/>
      <div class="font-weight-medium">Reinhard where a = .015 and LD_MAX = 2</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_reinhard_015.png`)"/>
      <div class="font-weight-medium">Reinhard where a = .015 and LD_MAX = 15</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/10_reinhard_ld25a15.png`)"/>
      <div class="font-weight-medium">Reinhard where a = .015 and LD_MAX = 25</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Ward Results</div><v-divider class="div-after"/>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_5.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 5</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_15.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 15</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_100.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 100</div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_250.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 250</div>


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_10',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[10];
    },
  },
}
</script>

<style>

</style>
